import { c as _c } from "react/compiler-runtime";
import styles from './BlogMdxImage.module.scss';
import { getBlogImageUrl } from '../model/blog-utils';
type BlogMdxImageProps = {
  src: string;
  alt?: string;
};

// MDX 본문에서 쓰는 아티클 이미지. 프록시 URL 변환(getBlogImageUrl)을 캡슐화한다.
export function BlogMdxImage(t0) {
  const $ = _c(5);
  const {
    src,
    alt: t1
  } = t0;
  const alt = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] !== src) {
    t2 = getBlogImageUrl(src);
    $[0] = src;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== alt || $[3] !== t2) {
    t3 = <img src={t2} alt={alt} className={styles.image} loading="lazy" />;
    $[2] = alt;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}